import React from "react";
import SectionHeader from "./SectionHeader";

const AREAS = [
  {
    t: "GST & indirect tax",
    d: "Show-cause notices, ITC disputes, Rule 86A blocking, refunds, appeals before appellate authorities and High Courts.",
  },
  {
    t: "Customs, Excise & Service Tax",
    d: "Classification, valuation and legacy CENVAT disputes before CESTAT and the courts.",
  },
  {
    t: "Income tax",
    d: "Reassessment, appeals before ITAT, CBDT instructions and circulars.",
  },
  {
    t: "Corporate & insolvency",
    d: "Proceedings before NCLT and NCLAT, with precedent tracked as it develops.",
  },
  {
    t: "Writs & constitutional",
    d: "Writ petitions before High Courts on natural justice, jurisdiction and limitation.",
  },
  {
    t: "Commercial litigation",
    d: "Contract, recovery and commercial-court matters, from pleadings to arguments.",
  },
];

const PracticeAreas = () => (
  <section className="vd-section vd-section--soft">
    <div className="container">
      <SectionHeader
        eyebrow="PRACTICE AREAS"
        title="Deep where Indian disputes are densest."
      />
      <div className="row g-4">
        {AREAS.map((a) => (
          <div className="col-md-6 col-lg-4" key={a.t}>
            <div className="vd-tile">
              <h3>{a.t}</h3>
              <p>{a.d}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default PracticeAreas;
